module.exports = __webpack_public_path__ + "img/D201810_2.4da5c2a6.jpg";